import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';

var config = process.env;

// Mismo orden que los bloques del POS (CafeteriaPosPage.CATEGORY_ORDER): esta lista es donde
// se decide ese orden, así que tiene que mostrarse agrupada igual que la pantalla que ordena.
const CATEGORY_ORDER = ['cold_drink', 'hot_drink', 'bakery', 'pizzeria', 'snack', 'other'];
// En singular: acá etiquetan UNA fila del listado, no un bloque como en el POS.
const CATEGORY_LABELS = {
    cold_drink: 'Bebida fría',
    hot_drink: 'Bebida caliente',
    bakery: 'Panadería',
    pizzeria: 'Pizzería',
    snack: 'Snack',
    other: 'Otro',
};

function money(value) {
    const n = Number(value || 0);
    return `$ ${n.toLocaleString('es-UY')}`;
}

class CafeteriaMenuPage extends Component {
    constructor() {
        super();
        this.state = { checked: false, role: 0, items: [], loading: true, movingCode: null };
    }

    async componentDidMount() {
        const role = await validateSession();
        this.setState({ checked: true, role });
        this.fetchItems();
    }

    fetchItems = () => {
        this.setState({ loading: true });
        const request = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'access-token': localStorage.getItem('token'),
            },
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'cafeteria/menu', request)
            .then((results) => results.json())
            .then((data) => {
                if (data.error > 0) {
                    alert(data.message);
                    if (data.error === 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                    this.setState({ loading: false });
                } else {
                    this.setState({ items: data.data || [], loading: false });
                }
            });
    }

    // Sube/baja el ítem dentro de su categoría. El backend renumera la categoría entera y
    // devuelve moved=false si ya estaba en la punta, así que acá alcanza con refrescar.
    moveItem = (code, direction) => {
        if (this.state.movingCode != null) {
            return; // una flecha a la vez: dos movimientos en vuelo se pisan el renumerado
        }
        this.setState({ movingCode: code });
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `cafeteria/menu/${encodeURIComponent(code)}/move`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'access-token': localStorage.getItem('token') },
            body: JSON.stringify({ direction }),
        })
            .then((results) => results.json())
            .then((data) => {
                this.setState({ movingCode: null });
                if (data.error > 0) {
                    alert(data.message);
                    return;
                }
                this.fetchItems();
            })
            .catch(() => {
                this.setState({ movingCode: null });
                alert('Error de red al reordenar.');
            });
    }

    // ENI-90: la columna "Stock" pasa a ser el estado de disponibilidad derivado de los insumos.
    renderAvailability(item) {
        if (Number(item.isRecipeBased) === 0) {
            return (<span className="text-muted">Sin control</span>);
        }
        if (item.sellable === false) {
            return (<span className="badge badge-warning">Falta receta</span>);
        }
        const n = item.available != null ? item.available : null;
        return (<span className={n != null && n <= 0 ? 'badge badge-danger' : ''}>{n != null ? n : '—'}</span>);
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        // El backend ya devuelve la lista ordenada (sort_order, después nombre); filtrar por
        // categoría preserva ese orden relativo, así que estos son exactamente los bloques
        // que va a dibujar el POS.
        const grouped = {};
        this.state.items.forEach((i) => {
            const c = CATEGORY_ORDER.indexOf(i.category) >= 0 ? i.category : 'other';
            if (!grouped[c]) grouped[c] = [];
            grouped[c].push(i);
        });
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={26} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <div className="d-flex justify-content-between align-items-center">
                                <HeaderComponent title="Cafetería" subtitle="Menú" />
                                <button type="button" className="btn btn-accent" onClick={() => navigateTo('/addCafeteriaMenu')}>
                                    + Nuevo ítem
                                </button>
                            </div>
                            <div className="card card-small mb-4">
                                <div className="card-body p-0">
                                    <table className="table mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Categoría</th>
                                                <th>Precio</th>
                                                <th>Preparación</th>
                                                <th>Disponibilidad</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.loading && (
                                                <tr><td colSpan="6" className="text-center">Cargando…</td></tr>
                                            )}
                                            {!this.state.loading && this.state.items.length === 0 && (
                                                <tr><td colSpan="6" className="text-center text-muted">No hay ítems de menú todavía.</td></tr>
                                            )}
                                            {/* Agrupado por categoría y en el MISMO orden que el POS: las flechas
                                                mueven dentro de la categoría, así que la lista tiene que verse igual
                                                que la pantalla que se está ordenando o el resultado sorprende. */}
                                            {CATEGORY_ORDER.filter((c) => grouped[c]).map((c) => ([
                                                <tr key={`h-${c}`} className="bg-light">
                                                    <td colSpan="6" className="py-1">
                                                        <strong style={{ fontSize: '.8rem' }}>{CATEGORY_LABELS[c] || c}</strong>
                                                        <span className="text-muted ml-2" style={{ fontSize: '.75rem' }}>
                                                            {grouped[c].length} · en este orden se ven en el POS
                                                        </span>
                                                    </td>
                                                </tr>,
                                                ...grouped[c].map((item, idx) => (
                                                <tr key={item.code}>
                                                    <td>{item.name}</td>
                                                    <td>{CATEGORY_LABELS[item.category] || item.category}</td>
                                                    <td>{money(item.price)}</td>
                                                    <td>{Number(item.requiresPrep) === 1 ? 'A preparar' : 'Entrega directa'}</td>
                                                    <td>{this.renderAvailability(item)}</td>
                                                    <td className="text-right text-nowrap">
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-white"
                                                            title="Subir en el POS"
                                                            disabled={idx === 0 || this.state.movingCode != null}
                                                            onClick={() => this.moveItem(item.code, 'up')}
                                                        >↑</button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-white mr-2"
                                                            title="Bajar en el POS"
                                                            disabled={idx === grouped[c].length - 1 || this.state.movingCode != null}
                                                            onClick={() => this.moveItem(item.code, 'down')}
                                                        >↓</button>
                                                        <button type="button" className="btn btn-sm btn-white" onClick={() => navigateTo(`/editCafeteriaMenu?code=${item.code}`)}>
                                                            Editar
                                                        </button>
                                                    </td>
                                                </tr>
                                                )),
                                            ]))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default CafeteriaMenuPage;
